<app-alert></app-alert>
<section class="panel panel-default">

    <div class="card-header">
            <title>SH-3 Register of Sweat Equity Shares</title>
        <span class="cat__core__title">
            <strong id="pageTitle">SH-3 Register of Sweat Equity Shares</strong>
        </span>
            <span style="float:right">
                <!-- <a routerLink="/sh3-list"> -->
                    <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
                        <i class=" fa fa-chevron-circle-left"></i>
                        Back
                    </button>
                <!-- </a> -->
            </span>
            <!-- <span style="float:right">
              <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
                <span>
                  <i class="fa fa-save"></i>Generate Output </span>
              </button>
      </span> -->
          
    </div>
    
  <div class ="row">
    <div class="col-lg-12" id="sh3TabContainer">
            <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#sh3sweatequitysharesmaster"
                        role="tab" [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                        SH-3 - Sweat Equity Share's Masters
                      </a>
                    </li>
                    <li class="nav-item">
                      <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab"
                        data-target="#totalsh3" role="tab" [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                        Total consideration paid, if any, by the employee / director
                      </a>
                    </li>
                    <li class="nav-item">
                      <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab"
                        data-target="#lockindetailsh3" role="tab" [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                        Lock in details
                      </a>
                    </li>
                    <li class="nav-item">
                      <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab"
                        data-target="#valuationdetailsh3" role="tab" [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                        Valuation details
                      </a>
                    </li>
            </ul>


<div class="tab-content">    
      <!-- sh-3 -->
      <div class="tab-pane active" id="sh3sweatequitysharesmaster" role="tabcard">
        <form [formGroup]='sh3Form' (document:click)="a.close();b.close();c.close()">
        <div class="modal-body">

           <div class="row">
            
                     
                                <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                                  <label class="form-control-label" for="l0">Reference to entry in register of members<span
                                      _ngcontent-c2="" style="color: red;">*</span></label>
                               
                                    <select [formControl]="sh3Form.controls['referenceToEntry']" class="form-control" style="padding: 6px;" (change)="sh3FormDetails($event, sh3Form.controls.referenceToEntry.value)"> 
                                          <option value="">Select any one</option>  
                                          <option *ngFor="let item of allotmentNoList; let i = index;" [attr.data-mgt1id]="item.MGT1_id" value="{{item.allotmentNo}}">  
                                              {{item.allotmentNo}}
                                          </option> 
                                    </select>
                                    <div *ngIf="sh3Form.controls['referenceToEntry'].hasError('required') && sh3Form.controls['referenceToEntry'].touched" class="form-control-error-custom">
                                     Reference to entry in register of members is required
                                    </div>
                                
                                   
                                 </div>

                                <div class=" form-group col-md-4 col-sm-6 col-xs-12">
                                        <label>Status of the allottee, whether director or employee<span _ngcontent-c2="" style="color: red;">*</span></label>
                                        <select  _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" name="statusOfAllotee" 
                                        [formControl]="sh3Form.controls['statusOfAllotee']" style="padding:6px;" required>
                                            <option _ngcontent-c2="" value="" selected>Select any one</option>
                                            <option _ngcontent-c2="" value="Director">Director</option>
                                            <option _ngcontent-c2="" value="Employee">Employee</option>
                                        <div *ngIf="sh3Form.controls['statusOfAllotee'].hasError('required') && sh3Form.controls['statusOfAllotee'].touched"
                                            class="form-control-error-custom">
                                            Status of the allottee, whether director or employee is required
                                        </div>
                                     </select>
                                       
                                </div>


                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Date of passing of Board resolution</label>
                                            <div class="form-group">
                                                <div class="input-group" (click)="$event.stopPropagation()">
                                                  <input class="form-control"  [formControl]="sh3Form.controls['dateOfPassingBoardResolution']" [(ngModel)]="dateOfPassingBoardResolutionModel"
                                                      style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                                      name="dateOfPassingBoardResolution" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();">
                                                  <button class="input-group-addon" (click)="a.toggle();"
                                                      type="button">
                                                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                  </button>
                                                </div>
                                                <div *ngIf="(sh3Form.controls['dateOfPassingBoardResolution'].hasError('pattern') || sh3Form.controls['dateOfPassingBoardResolution'].hasError('maxlength')) && sh3Form.controls['dateOfPassingBoardResolution'].touched"
                                                class="form-control-error-custom">
                                                Date of passing of Board resolution is invalid
                                            </div>
                                            </div>
                                        </div>

                    </div>
  
         <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of the special resolution authorizing the issue of sweat
                            equity shares</label>
                    <div class="form-group">
                        <div class="input-group" (click)="$event.stopPropagation()">
                          <input class="form-control"  [formControl]="sh3Form.controls['dateOfSpecialResoltuion']" [(ngModel)]="dateOfSpecialResoltuionModel"
                              style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                              name="dateOfSpecialResoltuion" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();">
                          <button class="input-group-addon" (click)="b.toggle();"
                              type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                          </button>
                        </div>
                        <div *ngIf="(sh3Form.controls['dateOfSpecialResoltuion'].hasError('pattern') || sh3Form.controls['dateOfSpecialResoltuion'].hasError('maxlength')) && sh3Form.controls['dateOfSpecialResoltuion'].touched"
                        class="form-control-error-custom">
                        Date of the special resolution authorizing the issue of sweat equity sharesis invalid
                    </div>
                    </div>
                </div>
                
                <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                        <label>Name of the allottee</label>
                        <div class="form-group">
                           
                                <select _ngcontent-c2="" class="form-control " 
                                [formControl]="sh3Form.controls['nameOfAllotee']"  (change)="changeAllotteeType(sh3Form.controls['nameOfAllotee'].value)"
                                style="padding:6px;">
                                                                                                            
                                <option _ngcontent-c2="" value="" [selected]="true" >
                                  Select any one
                                </option>
                                <option _ngcontent-c2="" value="Director" >
                                 Director
                                </option>
                                <option _ngcontent-c2="" value="Employee">
                                    Employee
                                </option>
                                </select>

                        </div>
               </div>

                  <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12"  *ngIf="sh3Form.controls.nameOfAllotee.value == 'Director'"><br>
                        <label class="form-control-label" for="l0">Director</label>
                     
                          <select [formControl]="sh3Form.controls['nameOfTheInterestedDirector']" class="form-control" style="padding: 6px;"> 
                                <option value="">Select any one</option>  
                                <option *ngFor="let director of masterDirectorList" value="{{director.FirstName + ' '+ director.LastName}}">  
                                    {{director.FirstName + " "+ director.LastName}}
                                </option> 
                          </select>
                 </div>

               <div class="col-md-4 col-sm-6 col-xs-12" *ngIf="sh3Form.controls.nameOfAllotee.value == 'Employee'"><br>
                        <label class="form-control-label">Employee</label>
                        <div class="form-group">
                        <input type="text" class="form-control" [formControl]="sh3Form.controls['employeeName']" placeholder="Enter name" (keydown)="noBlankSpaceAtStart($event)">
                        <div *ngIf="(sh3Form.controls['employeeName'].hasError('pattern') || sh3Form.controls['employeeName'].hasError('maxlength')) && sh3Form.controls['employeeName'].touched"
                         class="form-control-error-custom">
                         Employee Name is invalid
                      </div>
                    </div>
                </div>
                   
        </div>
  
        <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Date of issue of sweat equity shares</label>
                        <div class="form-group">
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input class="form-control"  [formControl]="sh3Form.controls['dateOfIssueOfSweat']" [(ngModel)]="dateOfIssueOfSweatModel"
                                  style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                  name="dateOfIssueOfSweat" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle();">
                              <button class="input-group-addon" (click)="c.toggle();"
                                  type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                            <div *ngIf="(sh3Form.controls['dateOfIssueOfSweat'].hasError('pattern') || sh3Form.controls['dateOfIssueOfSweat'].hasError('maxlength')) && sh3Form.controls['dateOfIssueOfSweat'].touched"
                            class="form-control-error-custom">
                            Date of issue of sweat equity shares is invalid
                        </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 col-xs-12">
                            <label class="form-control-label">Number of sweat equity shares issued<span _ngcontent-c2=""
                                style="color: red;">*</span>
                            </label>
                            <div class="form-group">
                            <input type="text" class="form-control" [formControl]="sh3Form.controls['numberofsweatequitysharesissued']" (keydown)="noBlankSpaceAtStart($event)">
                            <div *ngIf="(sh3Form.controls['numberofsweatequitysharesissued'].hasError('pattern') || sh3Form.controls['numberofsweatequitysharesissued'].hasError('maxlength')) && sh3Form.controls['numberofsweatequitysharesissued'].touched"
                             class="form-control-error-custom">
                             Number of sweat equity shares issued is invalid
                          </div>
                           <div *ngIf="sh3Form.controls['numberofsweatequitysharesissued'].hasError('required') && sh3Form.controls['numberofsweatequitysharesissued'].touched" class="form-control-error-custom">
                                Number of sweat equity shares issue is required
                             </div>
                        </div>
               </div>

               <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Certificate No.<span _ngcontent-c2=""
                        style="color: red;">*</span>
                    </label>
                    <div class="form-group">
                    <input type="text" class="form-control" [formControl]="sh3Form.controls['certificateNo']" (keydown)="noBlankSpaceAtStart($event)">
                    <div *ngIf="(sh3Form.controls['certificateNo'].hasError('pattern') || sh3Form.controls['certificateNo'].hasError('maxlength')) && sh3Form.controls['certificateNo'].touched"
                     class="form-control-error-custom">
                     Certificate No. is invalid
                  </div>
                   <div *ngIf="sh3Form.controls['certificateNo'].hasError('required') && sh3Form.controls['certificateNo'].touched" class="form-control-error-custom">
                        Certificate No. is required
                     </div>
                </div>
       </div>

</div>
  
        <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Folio No.<span _ngcontent-c2=""
                            style="color: red;">*</span>
                        </label>
                        <div class="form-group">
                        <input type="text" class="form-control" [formControl]="sh3Form.controls['folioNo']" (keydown)="noBlankSpaceAtStart($event)">
                        <div *ngIf="(sh3Form.controls['folioNo'].hasError('pattern') || sh3Form.controls['folioNo'].hasError('maxlength')) && sh3Form.controls['folioNo'].touched"
                         class="form-control-error-custom">
                         Folio No is invalid
                      </div>
                       <div *ngIf="sh3Form.controls['folioNo'].hasError('required') && sh3Form.controls['folioNo'].touched" class="form-control-error-custom">
                            Folio No is required
                         </div>
                    </div>
             </div>

             <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Face value of the share<span _ngcontent-c2=""
                        style="color: red;">*</span>
                    </label>
                    <div class="form-group">
                    <input type="text" class="form-control" [formControl]="sh3Form.controls['faceValue']" (keydown)="noBlankSpaceAtStart($event)">
                    <div *ngIf="(sh3Form.controls['faceValue'].hasError('pattern') || sh3Form.controls['faceValue'].hasError('maxlength')) && sh3Form.controls['faceValue'].touched"
                     class="form-control-error-custom">
                    Face value of the share is invalid
                  </div>
                   <div *ngIf="sh3Form.controls['faceValue'].hasError('required') && sh3Form.controls['faceValue'].touched" class="form-control-error-custom">
                       Face value of the share is required
                     </div>
                </div>
         </div>

            <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Price at which the shares are issued<span _ngcontent-c2=""
                        style="color: red;">*</span>
                    </label>
                    <div class="form-group">
                    <input type="text" class="form-control" [formControl]="sh3Form.controls['priceAtWhichSharesAreIssued']" (keydown)="noBlankSpaceAtStart($event)">
                    <div *ngIf="(sh3Form.controls['priceAtWhichSharesAreIssued'].hasError('pattern') || sh3Form.controls['priceAtWhichSharesAreIssued'].hasError('maxlength')) && sh3Form.controls['priceAtWhichSharesAreIssued'].touched"
                     class="form-control-error-custom">
                     Price at which the shares are issued is invalid
                  </div>
                   <div *ngIf="sh3Form.controls['priceAtWhichSharesAreIssued'].hasError('required') && sh3Form.controls['priceAtWhichSharesAreIssued'].touched" class="form-control-error-custom">
                        Price at which the shares are issued is required
                     </div>
                </div>
         </div>
  
        </div>
  
     <div class="row">

            <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Amount to be treated as paid up<span _ngcontent-c2=""
                        style="color: red;">*</span>
                    </label>
                    <div class="form-group">
                    <input type="text" class="form-control" [formControl]="sh3Form.controls['amountToBeTreatedAsPaidUp']" (keydown)="noBlankSpaceAtStart($event)">
                    <div *ngIf="(sh3Form.controls['amountToBeTreatedAsPaidUp'].hasError('pattern') || sh3Form.controls['amountToBeTreatedAsPaidUp'].hasError('maxlength')) && sh3Form.controls['amountToBeTreatedAsPaidUp'].touched"
                     class="form-control-error-custom">
                     Amount to be treated as paid up is invalid
                  </div>
                   <div *ngIf="sh3Form.controls['amountToBeTreatedAsPaidUp'].hasError('required') && sh3Form.controls['amountToBeTreatedAsPaidUp'].touched" class="form-control-error-custom">
                        Amount to be treated as paid up is required
                     </div>
                </div>
         </div>
                      
     </div>

    </div>
  
           

                  
                                <div class="card-footer" align="right">
                                    <div class="form-group" *ngIf="!restrictTabflag">
                                            <button class="btn btn-sm btn-primary" (click)="saveSh3()" type="button"
                                              [disabled]="!sh3Form.valid || disabledOnClick">
                                              <span id="saveUpdateDirector"> <i class="fa fa-save"></i> Save </span>
                                            </button>
                                          </div>
                                          <div class="form-group" *ngIf="restrictTabflag">
                                            <button class="btn btn-sm btn-primary" (click)="updateSh3()" type="button"
                                              [disabled]="!sh3Form.valid || disabledOnClick">
                                              <span id="saveUpdateDirector"> <i class="fa fa-save"></i> Update </span>
                                            </button>
                                          </div>
                                        </div>

                  </form>
                </div>
              <!-- total -->
                <div class="tab-pane" id="totalsh3" role="tabcard">
                    <form [formGroup]='totalForm'  (document:click)="ab.close()">
                        <div class="modal-body">
                              <div class="row">
                                
                                 <div class="col-md-4 col-sm-6 col-xs-12">
                                                <label class="form-control-label">Consideration received in cash
                                                </label>
                                                <div class="form-group">
                                                <input type="text" class="form-control" [formControl]="totalForm.controls['considerationReceivedInCash']" (keydown)="noBlankSpaceAtStart($event)">
                                                <div *ngIf="(totalForm.controls['considerationReceivedInCash'].hasError('pattern') || totalForm.controls['considerationReceivedInCash'].hasError('maxlength')) && totalForm.controls['considerationReceivedInCash'].touched"
                                                 class="form-control-error-custom">
                                                 Consideration received in cash is invalid
                                              </div>
                                               
                                            </div>
                                     </div>


                                            <div class="col-md-4 col-sm-6 col-xs-12">
                                              <label class="form-control-label">Particulars of consideration other than cash</label>
                                              <div class="input-group" (click)="$event.stopPropagation()">
                                                  <input class="form-control" 
                                                      [formControl]="totalForm.controls['particularsOfConsideration']"
                                                      [(ngModel)]="particularsOfConsiderationModel" style="padding:6px;z-index: 0;"
                                                      placeholder="dd-mm-yyyy" name="particularsOfConsideration" ngbDatepicker
                                                      #ab="ngbDatepicker" (click)="ab.toggle()">
                                                  <button class="input-group-addon" (click)="ab.toggle()"
                                                      type="button">
                                                      <span class="fa fa-calendar"
                                                          style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                  </button>
                                                  
                                              </div>
                                              <div
                                                  *ngIf="totalForm.controls['particularsOfConsideration'].hasError('pattern') && totalForm.controls['particularsOfConsideration'].touched"
                                                  class="form-control-error-custom">
                                                  Particulars of consideration other than cash is invalid
                                                 </div>
                                          </div>



                              </div>
                        </div>
                           
                            <div class="card-footer" align="right">
                                    <div class="form-group" *ngIf="addTotalBtn">
                                      <button class="btn btn-sm btn-primary" (click)="saveTotal()" type="button"
                                        [disabled]="!totalForm.valid || disabledOnClick">
                                        <span> <i class="fa fa-save"></i> &nbsp;Save </span>
                                      </button>
                                    </div>
                                    <div class="form-group" *ngIf="!addTotalBtn">
                                      <button class="btn btn-sm btn-primary" (click)="saveTotal()" type="button"
                                        [disabled]="!totalForm.valid || disabledOnClick">
                                        <span> <i class="fa fa-save"></i>&nbsp; Update </span>
                                      </button>
                                    </div>
                             </div>    
                             

                        </form>
                     </div>

                    <!-- lock -->
                     <div class="tab-pane" id="lockindetailsh3" role="tabcard">
                            <form [formGroup]='lockForm' (document:click)="bc.close()">
                                <div class="modal-body">
                                      <div class="row">

                                         <div class="col-md-4 col-sm-6 col-xs-12">
                                                        <label class="form-control-label">Lock in period (in months)
                                                        </label>
                                                        <div class="form-group">
                                                        <input type="text" class="form-control" [formControl]="lockForm.controls['lockInPeriod']" (keydown)="noBlankSpaceAtStart($event)">
                                                        <div *ngIf="(lockForm.controls['lockInPeriod'].hasError('pattern') || lockForm.controls['lockInPeriod'].hasError('maxlength')) && lockForm.controls['lockInPeriod'].touched"
                                                         class="form-control-error-custom">
                                                         Lock in period (in months) is invalid
                                                      </div>
                                                       
                                                    </div>
                                             </div>

                                               

                                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                                      <label class="form-control-label">The Date of expiry of lock- in-period</label>
                                                      <div class="input-group" (click)="$event.stopPropagation()">
                                                          <input class="form-control"
                                                              [formControl]="lockForm.controls['theDateOfExpiryOfLockInPeriod']"
                                                              [(ngModel)]="theDateOfExpiryOfLockInPeriodModel"
                                                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                              name="theDateOfExpiryOfLockInPeriod" ngbDatepicker #bc="ngbDatepicker"
                                                              (click)="bc.toggle()">
                                                          <button class="input-group-addon" (click)="bc.toggle()"
                                                              type="button">
                                                              <span class="fa fa-calendar"
                                                                  style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                          </button>
                                                      </div>
                                                     
                                                      <div
                                                          *ngIf="lockForm.controls['theDateOfExpiryOfLockInPeriod'].hasError('pattern') && lockForm.controls['theDateOfExpiryOfLockInPeriod'].touched"
                                                          class="form-control-error-custom">
                                                          The Date of expiry of lock- in-period is invalid
                                                         </div>
                                                  </div>
        
        
        
                                      </div>
                                </div>
                                   
                                    <div class="card-footer" align="right">
                                            <div class="form-group" *ngIf="addLockBtn">
                                              <button class="btn btn-sm btn-primary" (click)="saveLock()" type="button"
                                                [disabled]="!lockForm.valid || disabledOnClick">
                                                <span> <i class="fa fa-save"></i> &nbsp;Save </span>
                                              </button>
                                            </div>
                                            <div class="form-group" *ngIf="!addLockBtn">
                                              <button class="btn btn-sm btn-primary" (click)="saveLock()" type="button"
                                                [disabled]="!lockForm.valid || disabledOnClick">
                                                <span> <i class="fa fa-save"></i>&nbsp; Update </span>
                                              </button>
                                            </div>
                                     </div>    
        
                                </form>
                             </div>
                        
                             <!-- valuation -->
                             <div class="tab-pane" id="valuationdetailsh3" role="tabcard">
                              <form [formGroup]='valuationForm' (document:click)="ef.close()">
                                  <div class="modal-body">
                                        <div class="row">
  
                                           <div class="col-md-4 col-sm-6 col-xs-12">
                                                          <label class="form-control-label">Fair value obtained by Valuer
                                                          </label>
                                                          <div class="form-group">
                                                          <input type="text" class="form-control" [formControl]="valuationForm.controls['fairValueObtained']" (keydown)="noBlankSpaceAtStart($event)">
                                                          <div *ngIf="(valuationForm.controls['fairValueObtained'].hasError('pattern') || valuationForm.controls['fairValueObtained'].hasError('maxlength')) && valuationForm.controls['fairValueObtained'].touched"
                                                           class="form-control-error-custom">
                                                           Fair value obtained by Valuer is invalid
                                                        </div>
                                                         
                                                      </div>
                                               </div>

                                               <div class="col-md-4 col-sm-6 col-xs-12">
                                                  <label class="form-control-label">Basis of Valuation
                                                  </label>
                                                  <div class="form-group">
                                                  <input type="text" class="form-control" [formControl]="valuationForm.controls['basisOfValuation']" (keydown)="noBlankSpaceAtStart($event)">
                                                  <div *ngIf="(valuationForm.controls['basisOfValuation'].hasError('pattern') || valuationForm.controls['basisOfValuation'].hasError('maxlength')) && valuationForm.controls['basisOfValuation'].touched"
                                                   class="form-control-error-custom">
                                                   Basis of Valuation is invalid
                                                </div>
                                                 
                                              </div>
                                             </div>

                                             <div class="col-md-4 col-sm-6 col-xs-12">
                                                <label class="form-control-label">Name of Valuer
                                                </label>
                                                <div class="form-group">
                                                <input type="text" class="form-control" [formControl]="valuationForm.controls['nameOfValuer']" (keydown)="noBlankSpaceAtStart($event)">
                                                <div *ngIf="(valuationForm.controls['nameOfValuer'].hasError('pattern') || valuationForm.controls['nameOfValuer'].hasError('maxlength')) && valuationForm.controls['nameOfValuer'].touched"
                                                 class="form-control-error-custom">
                                                 Name of Valuer is invalid
                                              </div>
                                               
                                            </div>
                                          </div>
  
                                        </div>

                                        <div class="row">

                                           
                                            <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                                              <label class="form-control-label">Date of Joining of employee</label>
                                              <div class="input-group" (click)="$event.stopPropagation()">
                                                  <input class="form-control" 
                                                      [formControl]="valuationForm.controls['dateOfJoiningOfEmployee']"
                                                      [(ngModel)]="dateOfJoiningOfEmployeeModel" style="padding:6px;z-index: 0;"
                                                      placeholder="dd-mm-yyyy" name="dateOfJoiningOfEmployee" ngbDatepicker
                                                      #ef="ngbDatepicker" (click)="ef.toggle();">
                                                  <button class="input-group-addon" (click)="ef.toggle();"
                                                      type="button">
                                                      <span class="fa fa-calendar"
                                                          style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                  </button>
                                                 
                                              </div>
                                              <div
                                              *ngIf="valuationForm.controls['dateOfJoiningOfEmployee'].hasError('pattern') && valuationForm.controls['dateOfJoiningOfEmployee'].touched"
                                              class="form-control-error-custom">
                                              Date of Joining of employee is invalid
                                             </div>
                                          </div>

                                            
                                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                <label class="form-control-label">Remarks, if any</label>
                                                               <textarea class="form-control" (keydown)="noBlankSpaceAtStart($event)"

                                                                   [formControl]="valuationForm.controls['remarks']"
                                                                   ></textarea>



                                                               <div *ngIf="(valuationForm.controls['remarks'].hasError('pattern') || valuationForm.controls['remarks'].hasError('maxlength')) && valuationForm.controls['remarks'].touched"
                                                                   class="form-control-error-custom">
                                                                   Remarks, if any is invalid
                                                                </div>
                                            </div>

                                        </div>
                                  </div>
                                     
                                      <div class="card-footer" align="right">
                                              <div class="form-group" *ngIf="addValuationBtn">
                                                <button class="btn btn-sm btn-primary" (click)="saveValuation()" type="button"
                                                  [disabled]="!valuationForm.valid || disabledOnClick">
                                                  <span> <i class="fa fa-save"></i>&nbsp; Save </span>
                                                </button>
                                              </div>
                                              <div class="form-group" *ngIf="!addValuationBtn">
                                                <button class="btn btn-sm btn-primary" (click)="saveValuation()" type="button"
                                                  [disabled]="!valuationForm.valid || disabledOnClick">
                                                  <span> <i class="fa fa-save"></i>&nbsp; Update </span>
                                                </button>
                                              </div>
                                       </div>    
          
                                  </form>
                               </div>
                          



              </div>
            </div>
          </div>    

</section>